module.exports = __webpack_public_path__ + "9ead059fdfd8a8e502d75573d5cd8f00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/desktopBanner.jpg
// module id = 1784
// module chunks = 0